import { render, staticRenderFns } from "./ContractBasicInfoHeader.vue?vue&type=template&id=32ee63e8&"
import script from "./ContractBasicInfoHeader.vue?vue&type=script&lang=js&"
export * from "./ContractBasicInfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports